function configure(Highcharts) {
    Highcharts.setOptions({
        lang: {
            thousandsSep: ",",
            decimalPoint: ".",
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            numericSymbols: ["k", "M", "G", "T", "P", "E"],
            loading: "Loading...",
            contextButtonTitle: "Chart menu",
            printChart: "Print chart",
            downloadJPEG: "Download JPEG (image)",
            downloadPNG: "Download PNG (image)",
            downloadSVG: "Download SVG (image)",
            downloadPDF: "Download PDF (image)",
            downloadCSV: "Download CSV (data)",
            downloadXLS: "Download XLS (data)",
            viewFullscreen: "View in fullscreen",
            exitFullscreen: "Exit from fullscreen",
            zoomIn: "Zoom in",
            zoomOut: "Zoom out",
            resetZoom: "Reset zoom",
            resetZoomTitle: "Reset zoom level 1:1",
            rangeSelectorFrom: "From",
            rangeSelectorTo: "To",
            rangeSelectorZoom: "Zoom",
            drillUpText: "\u25c1 Back to {series.name}",
        }
    });
}
export default configure;
